import { createAsyncThunk } from '@reduxjs/toolkit'
import { BomItemAttachmentsController } from 'services/APIs/InternalAPI/AttachmentAPI'
import { ShowException } from 'store/Application/appActions'
import { GetContext } from 'store/storeUtils'

export const downloadAttachment = createAsyncThunk<any, any, { state: any }>(
  'bomItem/downloadAttachment',
  async (
    { bomItemId, fileName }: { bomItemId: string; fileName: string },
    thunkAPI
  ) => {
    const { partyId, projectId } = GetContext()
    const api = new BomItemAttachmentsController(partyId, projectId)

    try {
      return await api.DownloadFile(bomItemId, fileName)
    } catch (err) {
      ShowException('project', err)
      return thunkAPI.rejectWithValue(err)
    }
  }
)
